// extracted by mini-css-extract-plugin
export default {"app":"app_app__Bp+Bx","main":"app_main__T5WXm"};